import Header from '@/components/header';
import { GetStaticProps, GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import { fetchWebAPINavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import { Home } from 'src/features/home';
// Import Swiper styles
import 'swiper/css';
import CustomError from '@/features/errors';
import Popup from '@/components/popup';
import React from 'react';
import AppProvider from '@/context/AppProvider';
import fetchMessages from '@/fetchMessages';

export const getStaticProps: GetStaticProps = async (req: GetStaticPropsContext) => {
  const { messages, locale } = await fetchMessages(req.locale as string);

  const qs = locale ? `?locale=${locale}` : '';
  const path = `/home${qs}`;
  const [navigation, pageProps] = await Promise.all([
    fetchWebAPINavigation({ locale }),
    fetchWebAPIServerDataHandler(path, `[HOMEPAGE] PAGE: ${path}`),
  ]);

  const { props, notFound, redirect } = pageProps;

  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation, messages }, revalidate: 30 };

  return {
    props: {
      data: null,
      messages,
    },
  };
};

export default function Index({ data, error, ...props }: InferGetStaticPropsType<typeof getStaticProps>) {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data;
  return (
    <AppProvider navigation={props.navigation}>
      <HeadMetaTag meta={meta} />
      <Header />
      <Home data={data} />
      <Popup />
    </AppProvider>
  );
}
